export default "__VITE_ASSET__VR87HeUH__"